// Public UI adapted from Klargo-Reference/lib/i18n/languages.ts.
export const languages = [
    { flag: '🇸🇪', name: 'Svenska', code: 'sv' },
    { flag: '🇬🇧', name: 'English', code: 'en' }
];
